import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NotFound from './pages/NotFound'
import { getEnv } from './utils/environment'
import BaseContextWrapper from './components/common/BaseContext'
import { LanguageProvider } from './contexts/LanguageContext'
import Login from './pages/Login'
import ProtectedRoute from './components/common/ProtectedRoute'
import Borrow from './pages/Borrow'
import Categories from './pages/Categories'
import CategoryDetail from './pages/CategoryDetail'
import Products from './pages/Products'
import Archive from './pages/Archive'
import SettingsUser from './pages/settings/SettingsUser'
import Currency from './pages/settings/Currency'
import Bonus from './pages/Bonus'
import Supplier from './pages/Supplier'
import SupplierChecksDetail from './pages/SupplierChecksDetail'
import ClientOrders from './pages/ClientOrders'
import SupplierProductsDetail from './pages/SupplierProductsDetail'
import Documents from './pages/Documents'
import DocumentsCreate from './components/DocumentsCreate'
import DocumentsPreview from './pages/DocumentsPreview'
import ClientBorrowList from './components/ClientBorrowList'
import CashRegister from './pages/cash-register/CashRegister'
import Expenses from './pages/expenses/Expenses'
import Promotion from './pages/promotion/Promotion'
import PriceTags from './pages/price-tags/PriceTags'
import Inventory from './pages/inventory/Inventory'
import OrderReturn from './pages/OrderReturn'
import Nomenclature from './pages/nomenclature/Nomenclature'
import Home from './pages/Home'
import InventoryCreate from './pages/inventory/inventory-create'
import { SalesHistoryComponent } from './components/sales-history/SalesHistoryComponent'
import Users from './pages/Users'
// import BarcodeManager from './components/BarcodeManager'

export default function App() {
    useEffect(() => {
        if (getEnv() === 'production') return
        document.title = `${getEnv().toUpperCase()} ${document.title}`
    }, [])

    return (
        <LanguageProvider>
            <BrowserRouter>
                <BaseContextWrapper>
                    <Switch>
                        <Route path="/" component={Login} exact />
                        <ProtectedRoute path="/home" component={Home} exact />
                        <ProtectedRoute path="/sales-history" component={SalesHistoryComponent} exact />
                        <ProtectedRoute path="/cash-register" component={CashRegister} exact />
                        <ProtectedRoute path="/home" component={Home} exact />
                        <ProtectedRoute path="/archive/orders" component={Archive} exact />
                        <ProtectedRoute path="/archive/order/:orderID" component={OrderReturn} exact />
                        <ProtectedRoute path="/borrow" component={Borrow} exact />
                        <ProtectedRoute path="/borrow/:clientId" component={ClientBorrowList} exact />
                        <ProtectedRoute path="/documents-in" component={Documents} exact />
                        <ProtectedRoute path="/expense-report" component={Expenses} exact />
                        <ProtectedRoute path="/price-tags" component={PriceTags} exact />
                        <ProtectedRoute path="/promotion" component={Promotion} exact />
                        <ProtectedRoute path="/inventory" component={Inventory} exact />
                        <ProtectedRoute path="/documents-in/preview/:documentId" component={DocumentsPreview} exact />
                        <ProtectedRoute path="/documents-in/create" component={DocumentsCreate} exact />
                        <ProtectedRoute path="/inventory/create" component={InventoryCreate} exact />
                        <ProtectedRoute path="/products" component={Products} exact />
                        <ProtectedRoute path="/nomenclature" component={Nomenclature} exact />
                        <ProtectedRoute path="/supplier" component={Supplier} exact />
                        <ProtectedRoute path="/supplier/:supplierId/checks" component={SupplierChecksDetail} exact />
                        <ProtectedRoute path="/supplier/:supplierId/products" component={SupplierProductsDetail} exact />
                        <ProtectedRoute path="/client" component={Bonus} exact />
                        <ProtectedRoute path="/client/:clientId/order" component={ClientOrders} exact />
                        <ProtectedRoute path="/settings/user" component={SettingsUser} exact />
                        <ProtectedRoute path="/users" component={Users} exact />
                        {/* <ProtectedRoute path="/barcode" component={BarcodeManager} exact /> */}
                        <ProtectedRoute path="/settings/currency" component={Currency} exact />
                        <ProtectedRoute path="/settings/category" component={Categories} exact />
                        <ProtectedRoute path="/categories" component={Categories} exact />
                        <ProtectedRoute path="/category" component={CategoryDetail} exact />
                        <Route path="" component={NotFound} exact />
                    </Switch>
                </BaseContextWrapper>
            </BrowserRouter>
        </LanguageProvider>
    )
}
